import { instance } from "libs/api";

import {
  AiProductInfoStatusResponse,
  TriggerAiProductInfoBody,
  TriggerAiProductInfoResponse
} from "./aiProductInfo.types";

const ROUTE = "admin/ai/product-info";

export const requestTriggerAiProductInfo = async (
  body: TriggerAiProductInfoBody
): Promise<TriggerAiProductInfoResponse> => {
  return await instance.post(ROUTE, body);
};

export const requestAiProductInfoStatus = async (
  workflowId: string
): Promise<AiProductInfoStatusResponse> => {
  return await instance.get(`${ROUTE}/${workflowId}`);
};
